import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PresentationProvider } from './contexts/PresentationContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import PrivateRoute from './components/common/PrivateRoute';
import AppLayout from './components/layout/AppLayout';
import Login from './pages/auth/Login';
import EsqueciSenha from './pages/auth/EsqueciSenha';
import RedefinirSenha from './pages/auth/RedefinirSenha';
import ModoExibicao from './pages/modoExibicao/ModoExibicao';
import Dashboard from './pages/dashboard/Dashboard';
import Hospitais from './pages/hospitais/Hospitais';
import HospitalDetalhe from './pages/hospitais/HospitalDetalhe';
import Catalogo from './pages/catalogo/Catalogo';
import Usuarios from './pages/usuarios/Usuarios';
import Auditoria from './pages/auditoria/Auditoria';
import Perfil from './pages/perfil/Perfil';
import Novidades from './pages/novidades/Novidades';

function PrivateLayout({ children, perfil, bloqueiaEmApresentacao }) {
  return (
    <PrivateRoute perfil={perfil} bloqueiaEmApresentacao={bloqueiaEmApresentacao}>
      <AppLayout>{children}</AppLayout>
    </PrivateRoute>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <PresentationProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/esqueci-senha" element={<EsqueciSenha />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />

            <Route
              path="/modo-exibicao"
              element={
                <PrivateRoute semGateApresentacao>
                  <ModoExibicao />
                </PrivateRoute>
              }
            />

            <Route
              path="/dashboard"
              element={
                <PrivateLayout>
                  <Dashboard />
                </PrivateLayout>
              }
            />

            <Route
              path="/hospitais"
              element={
                <PrivateLayout perfil="operador">
                  <Hospitais />
                </PrivateLayout>
              }
            />
            <Route
              path="/hospitais/:idHospital"
              element={
                <PrivateLayout>
                  <HospitalDetalhe />
                </PrivateLayout>
              }
            />

            <Route
              path="/catalogo"
              element={
                <PrivateLayout perfil="operador">
                  <Catalogo />
                </PrivateLayout>
              }
            />

            <Route
              path="/usuarios"
              element={
                <PrivateLayout perfil="operador" bloqueiaEmApresentacao>
                  <Usuarios />
                </PrivateLayout>
              }
            />

            <Route
              path="/auditoria"
              element={
                <PrivateLayout perfil="admin" bloqueiaEmApresentacao>
                  <Auditoria />
                </PrivateLayout>
              }
            />

            <Route
              path="/perfil"
              element={
                <PrivateLayout>
                  <Perfil />
                </PrivateLayout>
              }
            />

            <Route
              path="/novidades"
              element={
                <PrivateLayout>
                  <Novidades />
                </PrivateLayout>
              }
            />

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          </PresentationProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
